import { render } from "./TagEditHeader.vue?vue&type=template&id=44a1d610"
import script from "./TagEditHeader.vue?vue&type=script&lang=js"
export * from "./TagEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__